import React, { useContext } from 'react'
import { useLocation } from 'react-router-dom'

import './header.scss'

import { UIContext } from '../../contexts/ui'

function Header(props) {
	const { Theme, setTheme } = useContext(UIContext)
	const onThemeChange = (event) => {
		setTheme(event.target.value)
	}
	let location = 'Simulator'
	switch (useLocation().pathname) {
		case '/expscaler':
			location = 'Exp Scaler'
			break
		case '/refine':
			location = 'Refine'
			break
		case '/news':
			location = 'Patch Notes'
			break
		case '/contact':
			location = 'Contact'
			break
		case '/about':
			location = 'About'
			break
		case '/index':
		default:
			location = 'Stats and Battle Simulator'
			break
	}
	// location = location.toUpperCase()
	return (
		<header className='Header'>
			<h1>{location}</h1>
			<nav>
				<ul>
					{/* <li>Log In</li> */}
					<li>
						Choose theme :
						<select
							name='ThemeSelector'
							id='ThemeSelector'
							onChange={onThemeChange}
							value={Theme}
						>
							<option value={0}>Basic</option>
							<option value={1}>Scrambling kid</option>
							<option value={2}>Metal</option>
						</select>
					</li>
				</ul>
			</nav>
		</header>
	)
}

export default Header
